<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="采购收货详情"
        class="customer-edit"
        width="1000px"
        top="10vh">
      <el-table v-loading="loading" :data="tableData" style="width: 100%">
        <el-table-column prop="evaluate" align="center" label="采购单号" width="120"/>
        <el-table-column prop="rowNum" align="center" label="行号" width="80"/>
        <el-table-column prop="partNo" align="center" label="物料编号" width="120"/>
        <el-table-column prop="partNameSpec" align="center" label="物料描述"/>
        <el-table-column prop="qty" align="center" label="数量" width="90"/>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"Preview",
    components: {},
    data() {
      return {
        dialogVisible: false,
        loading: false,
        tableData: [],
        purchaseNo:"",
        ruleValidate: {
        },
      };
    },
    methods: {
      open(purchaseNo) {
        this.dialogVisible = true;
        this.loading = true;
        this.purchaseNo = purchaseNo;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `sAPPurchaseOrderDetails/details/${this.purchaseNo}`)
          .then(resp => {
            this.tableData = resp;
            this.loading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>